import React, { Component } from 'react';
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { PootsyButton } from './DesignFunctions'
import { PootsyCheckboxInput, PootsyTextInput } from './InputsFunctions'
import PootsySelectInput from "./shared/PootsySelectInput";

import * as actions from "../actions/acSignup"
import InputsChangeHandler from "./InputsChangeHandler";

class SignUpForm extends Component {
	render() {

		let { t } = this.context

		let { first_name, last_name, email, telephone, password, password_confirmation } = this.props.data
		let { password_match, canSubmit, form_errors } = this.props.meta

		return(
			<InputsChangeHandler onChange={this.handleFormChanges}>
				<div className="SignUpInForm">
					<div className="signup-textinputs">
						<PootsyTextInput
							name="first_name"
							label={t('first_name_input_label')}
							value={first_name}
						/>
						<PootsyTextInput
							name="last_name"
							label={t('last_name_input_label')}
							value={last_name}
						/>
						<PootsyTextInput placeholder={t('email_input_placeholder')}
										 name="email"
										 label={t('email_input_label')}
										 value={email}
										 showError={t(form_errors["email"])}
						/>

						{this.renderGenderSelect()}


						<PootsyTextInput
							name="telephone"
							label={t('telephone_input_label')}
							value={telephone}
							showError={t(form_errors["telephone"])}
						/>

						<PootsyTextInput placeholder={t('password_input_placeholder')}
										 name="password"
										 label={t('password_input_label')}
										 value={password}
										 type="password"
						/>
						<PootsyTextInput placeholder={t('password_confirmation_input_placeholder')}
										 name="password_confirmation"
										 label={t('password_input_label')}
										 value={password_confirmation}
										 type="password"
										 showError={!password_match ? t('passwords_dont_match') : ""}
										 onKeyPress={this.handleSubmit}
						/>

					</div>
					<div className="create-account-checkboxes">
						<PootsyCheckboxInput label={t('accept_cgu')}
											 name="accept_cgu"
						/>
						<PootsyCheckboxInput label={t('accept_emails')}
											 name="accept_emails"
						/>
					</div>
					<PootsyButton text={t('signup')}
								  onClick={this.onCreateAccountButtonClick}
								  disabled={!canSubmit}
					/>
				</div>
			</InputsChangeHandler>
		)
	}

	renderGenderSelect = () => {

		let { t } = this.context
		let { title } = this.props.data

		let options = [
			{
				value: 'mr',
				label: t('gender_mr')
			},
			{
				value: 'mrs',
				label: t('gender_mrs')
			}
		]

		return (
			<PootsySelectInput options={options}
							   onChange={this.onGenderSelected}
							   label={t('gender')}
							   selectedValue={title}
							   defaultValue={''}
			/>
		)
	}

	handleFormChanges = changes => {
		this.props.dispatch(actions.processDataChange(changes))
	}

	onGenderSelected = (changes) => {
		this.props.dispatch(actions.processDataChange({ title: changes.value }))
	}

	onCreateAccountButtonClick = () => {
		this.props.dispatch(actions.signup())
	}

	handleSubmit = e => {
		if(e.key === 'Enter'){
			this.props.dispatch(actions.signup())
		}
	}
}

const mapStateToProps = state => ({
	data: state.dataReducer.signup,
	meta: state.metadataReducer.signup
})

SignUpForm.contextTypes = { t: PropTypes.func }
export default connect(mapStateToProps)(SignUpForm);


// WEBPACK FOOTER //
// ./src/components/SignUpForm.js